import { apiClient } from './client';
import { API_ENDPOINTS } from './config';

export interface SessionResponse {
  id: string;
  userId: string;
  deviceId: string;
  deviceName: string;
  deviceType: 'desktop' | 'laptop' | 'mobile' | 'tablet';
  browser: string;
  userAgent: string;
  ipAddress?: string;
  location?: string;
  lastActive: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateSessionRequest {
  deviceId: string;
  deviceName: string;
  deviceType: 'desktop' | 'laptop' | 'mobile' | 'tablet';
  browser: string;
  userAgent: string;
  ipAddress?: string;
  location?: string;
}

export const sessionsApi = {
  async create(data: CreateSessionRequest): Promise<SessionResponse> {
    return apiClient.post<SessionResponse>(API_ENDPOINTS.SESSIONS.BASE, data);
  },

  async getAll(): Promise<SessionResponse[]> {
    return apiClient.get<SessionResponse[]>(API_ENDPOINTS.SESSIONS.BASE);
  },

  async delete(id: string): Promise<void> {
    return apiClient.delete<void>(API_ENDPOINTS.SESSIONS.BY_ID(id));
  },
};
